import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPaddle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M49.518 8.5c22.425-5.47 32.721-6 42.95-6 4.883 0 4.993.268 5.003 5.095l.075 5.039c-.16 4.585-.1 4.613-5.078 4.872-3.248.17-15.626.307-19.38 5.039s-4.662 10.939-3.757 21.51c.624 7.282 1.918 21 2 28.35S63.918 85.5 58.841 85.5H35.443c-6.095 0-13.006-5.322-13.003-13.095s14.075-52.81 14.075-52.81c1.583-5.94 6.99-9.281 13.003-11.095z" })
});
export default SvgPaddle;
